@if (value()) { @if (disabledFormat()) {
{{ value() }}
} @else {
{{ value() | percent : "1.2-2" }}
} } @else { - }
